let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jJJ76")).then(() => parcelRequire('j4Z7R'));